export const ItemTypes = {
    TASK: "task-item",
    RECURRING_TASK: "recurring-task-item",
} as const;
